import React from 'react';
import { motion } from 'framer-motion';

interface AnimatedSectionProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  animationType?: 'fade' | 'slide' | 'zoom' | 'bounce';
  animate?: boolean;
}

const AnimatedSection: React.FC<AnimatedSectionProps> = ({
  children,
  style,
  animationType = 'fade',
  animate = true,
}) => {
  const variants = {
    fade: {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 },
    },
    slide: {
      initial: { opacity: 0, y: 50 },
      animate: { opacity: 1, y: 0 },
      exit: { opacity: 0, y: -50 },
    },
    zoom: {
      initial: { scale: 0.5, opacity: 0 },
      animate: { scale: 1, opacity: 1 },
      exit: { scale: 0.5, opacity: 0 },
    },
    bounce: {
      initial: { y: -20, opacity: 0 },
      animate: { y: 0, opacity: 1 },
      exit: { y: -20, opacity: 0 },
    },
  };

  const MotionDiv = animate ? motion.div : 'div';

  return (
    <MotionDiv
      initial="initial"
      animate={animate ? 'animate' : undefined}
      exit={animate ? 'exit' : undefined}
      variants={animate ? variants[animationType] : undefined}
      transition={animate ? { duration: 0.5, ease: 'easeInOut' } : undefined}
      style={style}
    >
      {children}
    </MotionDiv>
  );
};

export default AnimatedSection;
